import { useFormikContext } from 'formik';
import { useContext } from 'react';

import { Button } from '../../../../cdl/Button/Button';
import { Text } from '../../../../cdl/Text/Text';
import { ButtonGroup } from '../../../../common/buttons/ButtonGroup';
import { FormikCustomerCompanyMultiSelect } from '../../../../common/form-elements/formik/FormikCustomerCompanyMultiSelect';
import { translate } from '../../../../common/helpers/translate.helper';
import { useRole } from '../../../../common/hooks/useRole';
import { IconArrowLeft } from '../../../../common/icons/cdl/ArrowLeft';
import { Box } from '../../../../common/ui/Box';

import { ContinueButton } from './ContinueButton';
import { CreateWebhookContext } from './CreateWebhookContext';
import { CreateWebhookFormState, CreateWebhookFormSteps } from './CreateWebhookModalContent';
import { WebhookFormButtonArea } from './WebhookFormButtonArea';

export const FormikWebhookDesideTriggers = () => {
    const role = useRole();
    const { setActiveFormStep } = useContext(CreateWebhookContext);
    const { values } = useFormikContext<CreateWebhookFormState>();

    return (
        <Box display="grid" gap={16}>
            <Box display="grid" gap={8}>
                <Text variant="title">{translate('webhooks.decideTrigger.title')}</Text>
                <Text variant="small">{translate('webhooks.decideTrigger.description')}</Text>
            </Box>

            <FormikCustomerCompanyMultiSelect
                name="customerIds"
                label={translate('webhooks.companies')}
                groupId={!role.isSuperAdmin() ? role.group.id : undefined}
            />

            <WebhookFormButtonArea>
                <ButtonGroup>
                    <Button
                        type="button"
                        onClick={() => setActiveFormStep(CreateWebhookFormSteps.SELECT_EVENTS)}
                        LeadingIcon={IconArrowLeft}
                    >
                        {translate('btn.back')}
                    </Button>
                    <ContinueButton
                        type="button"
                        disabled={!values.customerIds.length}
                        onClick={() => setActiveFormStep(CreateWebhookFormSteps.CONFIGURE_DESTINATION)}
                    />
                </ButtonGroup>
            </WebhookFormButtonArea>
        </Box>
    );
};
